<template>
	<div class="container-fluid" role="region" aria-label="Class Listing">
		<div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ ariaSummary }}</div>
		<div v-if="days.length > 0" class="calendar-container">
			<div class="calendar">

				<div class="day" v-for="(dayItem, dayIdx) in days" :key="dayIdx">
					<div v-if="dayItem.eventData.total === 0">
						<div class="planner-entry no-results">
							<p>No results for this day.
								<span v-if="isProspectMode"><a @click="showProspectFilters" role="button" data-anchor-button>Adjust your selection</a> to view more classes.</span>
							</p>
						</div>
					</div>
					<div v-for="(dayPart, dayPartIndex) in dayItem.eventData.dayParts" :key="dayPartIndex">
						<div v-if="dayPart.startTimes.length > 0" class="planner-daypart" :class="'planner-daypart-'+dayPart.name.toLowerCase()">
							<div class="planner-daypart-label">
								{{ dayPart.name }}
							</div>
						</div>
						<div class="planner-times" v-for="(startTime, startTimeIndex) in dayPart.startTimes" :key="startTimeIndex" :class="{'future-time': startTime.timestamp > now}">
							<div class="planner-entry" data-testid="classCell" v-for="(activity, activityIndex) in startTime.activities" :key="activityIndex" :class="{ 'card-danger': activity.isCanceled }">
								<p v-if="!isProspectMode && !isPrintingWeekView && startTime.timestamp > now" class="invisible" :class="{ 'card-cta-placeholder': !isInlineMode }">{{ activity.cta }}</p>
								<p class="small" v-html="parseTimes(startTime.time, activity.endTime)"></p>
								<p class="planner-entry-title">
									<span class="text-danger" v-if="activity.isCanceled">Canceled </span>
									<a :href="isProspectMode ? '' : `${classDetailsUrl}?eventId=${activity.id}`" @click="$emit('classClicked', $event, activity.name, activity.description)" data-testid="classLink">
										<span v-if="activity.isCanceled"><s>{{ activity.name }}</s></span>
										<span v-else>{{ activity.name }}</span>
									</a>
									<span v-if="activity.isPaidClass" :data-testid="`isPaidClass_${activity.id}`"><span class="ico-pay mylt-green"></span><span class="sr-only"> (paid class)</span></span>
								</p>
								<p :data-testid="`instructorName_${activity.id}`" v-if="activity.instructors.length > 0" v-html="buildInstructors(activity.instructors)"></p>
								<p :data-testid="`location_${activity.id}`">{{ activity.location }}</p>
								<p v-if="!isProspectMode && !isPrintingWeekView && startTime.timestamp > now" :class="{ 'card-cta': !isInlineMode }"><a :href="`${classDetailsUrl}?eventId=${activity.id}`" data-testid="reserveLink">{{ activity.cta }}</a></p>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { FrameworkService } from '@/services/framework.service';
import { clockObservable$, dateProvider } from '@/services/clock.service';
import { Helpers } from '@/common/helpers';

let clockSubscription;

export default defineComponent({
	name: 'WeekViewSub',
	props: {
		days: {
			default: () => [],
			type: Array
		},
		selectedDate: {
			default: null,
			type: Object
		},
		isInlineMode: {
			type: Boolean,
			default: false
		},
		isProspectMode: {
			type: Boolean,
			default: false
		},
		isPrintingWeekView: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			now: dateProvider(),
			classDetailsUrl: ''
		};
	},
	computed: {
		ariaSummary() {
			if (this.days.length) {
				let totalWeek = 0;
				for (const day of this.days) {
					totalWeek += day.eventData.total;
				}
				return `${totalWeek} class results for the week of ${this.days[0].display.ariaDate}`;
			}
			return 'Loading class schedules';
		}
	},
	created() {
		clockSubscription = clockObservable$
			.subscribe(m => {
				this.now = m;
			});
	},
	async mounted() {
		this.completeMounting();
	},
	destroyed() {
		clockSubscription.unsubscribe();
	},
	methods: {
		completeMounting() {
			this.classDetailsUrl = FrameworkService.clubUrl('classDetails');
		},
		parseTimes(startTime, endTime) {
			return Helpers.parseTimes(startTime, endTime);
		},
		buildInstructors(instructors) {
			return Helpers.buildInstructors(instructors);
		},
		dateHeadingScreenReader(dateStr) {
			const dateDisplay = Helpers.parseDateToMoment(dateStr);
			return dateDisplay.format('dddd, MMMM D');
		},
		showProspectFilters() {
			$('#filtersSub').collapse('show');
			$('.inline-mode-scroller').scrollTop(0);
		}
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/weekView.scss";
</style>
